import { jsx } from 'react/jsx-runtime';
import UITooltip from '@phx-husky/tooltip';
import { RTEText } from '@promo-platform/rte-text';
import { useState } from 'react';

const InfoIcon = ({ isHover }) => {
    const path = isHover
        ? 'M17.5,2A15.5,15.5,0,1,0,33,17.5,15.506,15.506,0,0,0,17.5,2Zm1.55,23.25h-3.1v-9.3h3.1Zm0-12.4h-3.1V9.75h3.1Z'
        : 'M15.95,9.75h3.1v3.1h-3.1Zm0,6.2h3.1v9.3h-3.1ZM17.5,2A15.5,15.5,0,1,0,33,17.5,15.506,15.506,0,0,0,17.5,2Zm0,27.9A12.4,12.4,0,1,1,29.9,17.5,12.416,12.416,0,0,1,17.5,29.9Z';
    return (jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 31 31" }, { children: jsx("path", { id: "Path_567", "data-name": "Path 567", d: path, transform: "translate(-2 -2)" }) })));
};

const convertRTEtoPlainText = (rteText) => JSON.parse(rteText)
    .blocks.map(({ text }) => text)
    .join('\n');

const Tooltip = ({ text, label }) => {
    const [isHover, setIsHover] = useState(false);
    return (jsx("div", Object.assign({ className: "pp-tooltip" }, { children: jsx(UITooltip, Object.assign({ placement: "top-end", className: "pp-tooltip-window", title: jsx(RTEText, { text: text }) }, { children: jsx("button", Object.assign({ type: "button", onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false), className: "pp-tooltip__button", "aria-label": label || convertRTEtoPlainText(text) }, { children: jsx(InfoIcon, { isHover: isHover }) })) })) })));
};

export { Tooltip };
